


































import {Component, PropSync, Watch} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {AddressBookContactsFilter} from "@/store/addressbooks/types";
import FilterSelectedItemWings from "@/components/Filter/FilterSelectedItemWings.vue";
import {FilterWings, SelectWings} from "@/components";
import {notifyError, notifyWarning} from "@/utils/notify-helper";

@Component({components: {FilterSelectedItemWings, SelectWings, FilterWings}})
export default class AddressbookContactsFilter extends BaseFilter<AddressBookContactsFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Action("getAddressBookContacts") actionGetItems: any;

  defaultFilter(): AddressBookContactsFilter {
    return new AddressBookContactsFilter(this.$route.params.id)
  }

  created() {
    this.filter.groupId = this.$route.params.id
    this.filtered();
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      const resp = await this.actionGetItems(this.filter);
      if (resp.data?.contacts?.length == 0) {
        if (!nextPage) notifyWarning()
        this.is_last = true
      } else {
        this.is_last = false
      }
    } catch(error) {
      notifyError(error);
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: any) {
    this.propFilterClone = val;
  }

  @Watch('propRunFilter', {immediate: true})
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }

}
